export default __webpack_public_path__ + "static/accesSOS-logo-cea1367bdbe94a2d4f9784ff29af710b.svg";